/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Field, Form } from 'formik';
import { Button, Col, Row } from 'reactstrap';
import { ADD_EDIT_CONSTANT, currencyUnitData } from 'utils/constants';
import { generateRandomString } from 'pages/OfferCoupons/constants';
import FormikInputField from 'components/Fields/FormikInputField';
import LoadingButton from 'components/common/LoadingButton';
import FormikDateRangePicker from 'components/Fields/FormikDateRangePicker';
import ReactSelect from 'components/Fields/ReactSelect';
import CouponIcon from 'assets/coupon-star.svg';
import CardWithTitle from 'components/CardWithTitle';

const AddEditOfferCouponForm = (props) => {
  const {
    handleSubmit,
    drawerToggle,
    isValid,
    dirty,
    isSubmitting,
    setFieldValue,
    type,
    values,
  } = props;

  const handleGenerateCode = () => {
    const randomString = generateRandomString();
    setFieldValue('code', randomString);
  };

  const handleChange = (newValue) => {
    setFieldValue('discountType', newValue, true);
    if (newValue?.id === 'FLAT') {
      setFieldValue('currency', currencyUnitData[0], true);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <CardWithTitle title="Coupon Details">
        <Row>
          <Col sm={5}>
            <Field
              label="Discount Type"
              name="discountType"
              type="select"
              component={ReactSelect}
              data={[
                { id: 'PERCENTAGE', label: 'PERCENTAGE' },
                { id: 'FLAT', label: 'FLAT' },
              ]}
              keys={{ id: 'id', label: 'label' }}
              getOptionValue={(option) => option.id}
              getOptionLabel={(option) => option.label}
              onChange={handleChange}
            />
          </Col>
          <Col sm={5}>
            <Row>
              <Col>
                <Field
                  label="Discount Value"
                  name="discountValue"
                  type="number"
                  component={FormikInputField}
                  required
                />{' '}
              </Col>
              {/* {values?.discountType?.id === 'FLAT' && ( */}
              <Col>
                <Field
                  label="Currency"
                  name="currency"
                  type="select"
                  component={ReactSelect}
                  data={currencyUnitData}
                  // defaultValue={currencyUnitData}
                  keys={{ id: 'id', label: 'label' }}
                  getOptionValue={(option) => option.id}
                  getOptionLabel={(option) => option.label}
                />
              </Col>
              {/* )} */}
            </Row>
          </Col>
        </Row>

        <Row>
          <Col sm={5} className="mt-3 d-flex position-relative">
            <Field
              label="Enter/Generate Coupon Name"
              name="code"
              type="text"
              component={FormikInputField}
              disabled={type === ADD_EDIT_CONSTANT.EDIT}
              required
            />
            <Button
              color="primary"
              className="ms-3 bg-transparent border-0 position-absolute end-0"
              style={{ marginTop: '21px' }}
              size="sm"
              onClick={handleGenerateCode}
              disabled={type === ADD_EDIT_CONSTANT.EDIT}
            >
              <img src={CouponIcon} alt="coupon-icon" />
            </Button>
          </Col>
          <Col sm={5} className="mt-3">
            <Field
              label="Usage Limit"
              name="usageLimit"
              type="number"
              component={FormikInputField}
              required
            />
          </Col>

          {/* <FSBDateAndTimePicker /> */}
          {/* <Col sm={12} className="mt-3">
          <Field
            label="Validity Period"
            name="description"
            type="text"
            component={FormikInputField}
            required
          />
        </Col> */}
        </Row>
        <Row>
          <Col sm={5} className="mt-3">
            <Field
              label="Valid from"
              name="fromDate"
              type="text"
              timeInputLabel="Time:"
              dateFormat="MM/dd/yyyy h:mm aa"
              showTimeInput
              component={FormikDateRangePicker}
              minDate={new Date()}
              onChange={(date) => {
                setFieldValue('fromDate', date, true);
                setFieldValue('expiryDate', date, true);
              }}
              disabled={type === ADD_EDIT_CONSTANT.EDIT}
            />
          </Col>

          <Col sm={5} className="mt-3">
            <Field
              label="Valid till"
              name="expiryDate"
              type="text"
              timeInputLabel="Time:"
              dateFormat="MM/dd/yyyy h:mm aa"
              showTimeInput
              component={FormikDateRangePicker}
              minDate={values?.fromDate}
              // selected={values?.fromDate || values?.expiryDate}
              onChange={(date) => {
                setFieldValue('expiryDate', date, true);
              }}
            />
          </Col>
        </Row>
      </CardWithTitle>
      <div className="form-btn d-flex justify-content-end mt-4">
        <Button
          color="secondary"
          outline
          size="sm"
          type="button"
          className="me-2 mw-100"
          onClick={() => drawerToggle('', ADD_EDIT_CONSTANT.ADD)}
        >
          Cancel
        </Button>
        <LoadingButton
          className="mw-100 loading-button"
          loading={isSubmitting}
          disabled={!isValid || !dirty || isSubmitting}
          color="warning"
          size="sm"
          type="submit"
        >
          {type === ADD_EDIT_CONSTANT.EDIT ? 'Update' : 'Create'}
        </LoadingButton>
      </div>
    </Form>
  );
};

export default AddEditOfferCouponForm;
